import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../messages'

export const SettingsImportLearnMoreLink = ({
  linkMessage = messages.learnMore,
  href,
}) => {
  const intl = useProcurifyIntl()

  return (
    <a
      target='_blank'
      rel='noopener noreferrer'
      href={href}
      style={{ display: linkMessage ? 'inline' : 'block' }}
    >
      {intl.formatMessage(linkMessage)}
    </a>
  )
}
